import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
//import { debounce } from '@mui/material/utils';
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { SerializedError } from "../../util/types";
import Metadata from "../metadata/Metadata";
import { Contact, ContactEditRequest } from "./contactSlice";
import { Filter, fromText } from "../filter/filterSlice";
import {
    useGetContactQuery,
    useSearchContactsQuery,
    useSearchContactsByIdQuery,
} from "../../api/contact";

interface QueryPropsNullable {
    contacts: { [key: string]: Contact };
    onChange: (contacts: { [key: string]: Contact }) => void;
    onRemove: (contact: Contact) => void;
    onAdd: (contact: Contact) => void;
}

interface QueryProps {
    contacts: { [key: string]: Contact };
    onChange: (contacts: { [key: string]: Contact }) => void;
    onRemove: (contact: Contact) => void;
    onAdd: (contact: Contact) => void;
}

const initialOptions = ["Opt 1", "Opt 2"];

export default function AutoComplete({
    contacts,
    onChange,
    onRemove,
    onAdd,
}: QueryPropsNullable) {
    return (
        <ParentFetchComplete
            contacts={contacts}
            onChange={onChange}
            onRemove={onRemove}
            onAdd={onAdd}
        />
    );
}

export function ParentFetchComplete({
    contacts,
    onChange,
    onRemove,
    onAdd,
}: QueryProps) {
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useSearchContactsByIdQuery({ ids: contacts });
    let content: React.ReactNode;
    if (isLoading) {
        content = <ContactViewerFetching />;
    } else if (isFetching) {
        content = <ContactViewerFetching />;
    } else if (isSuccess) {
        //console.log("202411131337", data);
        //let contacts_ar: Contact[] = Object.values(data.contacts);
        content = (
            <ParentCompleteSuccess
                contacts={data.contacts}
                onChange={onChange}
                onRemove={onRemove}
                onAdd={onAdd}
            />
        );
    } else if (isError) {
        content = <ContactViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}

interface PCProps {
    contacts: { [key: string]: Contact };
    //contact_ids: string[];
    onChange: (contacts: { [key: string]: Contact }) => void;
    onRemove: (contact: Contact) => void;
    onAdd: (contact: Contact) => void;
}

function ti_map_to_ti_list(
    //parent: Contact | null,
    items: { [key: string]: Contact },
): (Contact | null)[] {
    let result: (Contact | null)[] = [];
    for (const key in items) {
        //if (!parent || (parent && parent.metadata.id !== key)) {
        result.push(items[key]);
        //}
    }

    return result;
}

export function XParentCompleteSuccess({
    //contact_ids,
    contacts,
    onChange,
}: PCProps) {
    return <Box>Ok</Box>;
}
export function ParentCompleteSuccess({
    //contact_ids,
    contacts,
    onChange,
    onRemove,
    onAdd,
}: PCProps) {
    //const [contactsValue, setContacts] = React.useState<{
    //    [key: string]: Contact;
    //}>(contacts);
    const [contactsValue, setContacts] = React.useState<Contact[]>(
        Object.values(contacts),
    );
    const [value, setValue] = React.useState<Contact | null>(null);
    const [inputValue, setInputValue] = React.useState("");
    const handleRemoveContact = (toRemove: Contact) => {
        let newValue = contactsValue.filter(
            (c) => c.metadata.id !== toRemove.metadata.id,
        );
        setContacts(newValue);
        const map = Object.fromEntries(
            newValue.map((c) => [String(c.metadata.id), c]),
        );
        onChange(map);
    };

    const handleAddContact = (newContact: Contact) => {
        let newValue = contactsValue.some(
            (c) => c.metadata.id === newContact.metadata.id,
        )
            ? contactsValue
            : [...contactsValue, newContact];
        const map = Object.fromEntries(
            newValue.map((c) => [String(c.metadata.id), c]),
        );
        setContacts(newValue);
        onChange(map);
        /*
        setContacts((prev) => {
            // avoid duplicates by id if you want
            if (prev.some((c) => c.metadata.id === newContact.metadata.id)) {
                return prev;
            }
            return [...prev, newContact];
        });
        // */
    };
    //const [debouncedInput, setDebouncedInput] = useState(
    //    parent ? parent.first_name : "",
    //);
    //const [options, setOptions] = React.useState<(TicketItem | null)[]>(initialOptions);
    //console.log("202411191023 autocomplete start value", value);
    //console.log("202411191023 autocomplete start inputValue", inputValue);
    //console.log("202411191023 autocomplete start childType", ctype);
    //console.log("202411191023 autocomplete start debounce", debouncedInput);
    //const sameParent =
    //    parent && parent.first_name === inputValue ? true : false;
    const selectedValue = React.useMemo(() => value, [value]);
    const mInputValue = React.useMemo(() => inputValue, [inputValue]);
    //const changed = React.useMemo(() => inputValue, [inputValue]);
    const { data, isLoading, isFetching, isSuccess, isError, error } =
        useSearchContactsQuery(fromText(inputValue), {
            //} = useTicketParentQuery({ktype: childType ? childType : "", inputValue: debouncedInput}, {
            //skip: (debouncedInput.length < 3 || debouncedInput === inputValue),
            skip: inputValue.length < 3,
        });
    /*
		if (isSuccess) {
			let til = ti_map_to_ti_list(data.ticket_items);
			console.log("202411182258 is success", til);
			setOptions(til);
		}
		// */
    //}, [inputValue]);
    // */
    const options = React.useMemo(() => {
        if (data) {
            return ti_map_to_ti_list(/*parent,*/ data.contacts);
        } else {
            return [];
        }
    }, [data]);
    return (
        <>
            <ChipStack
                contacts={contactsValue}
                onRemove={/*onRemove*/ handleRemoveContact}
            />
            <br />
            <Autocomplete
                value={selectedValue}
                loading={isLoading || isFetching}
                onChange={(event: any, newValue: Contact | null) => {
                    if (newValue) handleAddContact(newValue);
                    /*
                    console.log(
                        "202411150809 autocomplete onchange value",
                        newValue,
                    );
                    if (!newValue) {
                        onChange(contacts);
                        return;
                    }

                    const existId = newValue.metadata.id;
                    const vnewContacts =
                        existId && contacts[existId]
                            ? contacts // do NOT add
                            : { ...contacts, newValue }; // add only if not existing
                    setValue(newValue);
                    onChange(vnewContacts);
                    // */
                    /*
                    let vnewContacts: Contact[] = newValue
                        ? [...contacts, newValue]
                        : contacts;
                    setValue(vnewContacts);
                    onChange(vnewContacts);
                    //setValue(null);
                    // */
                }}
                inputValue={mInputValue}
                onInputChange={React.useCallback(
                    (event: React.SyntheticEvent, newInputValue: string) => {
                        console.log("202411191021 autocomplete", newInputValue);
                        setInputValue(newInputValue);
                    },
                    [],
                )}
                id="parent-id"
                options={options}
                getOptionLabel={(option: Contact | null) => {
                    return option
                        ? option.first_name + " " + option.last_name
                        : "";
                }}
                getOptionKey={(option: Contact | null): string =>
                    option && option.metadata.id ? option.metadata.id : ""
                }
                isOptionEqualToValue={(
                    option: Contact | null,
                    value: Contact | null,
                ) => {
                    if (option && value) {
                        if (option.metadata.id === value.metadata.id)
                            return true;
                    }
                    if (!option && !value) {
                        return true;
                    }
                    return false;
                }}
                renderInput={(params) => (
                    <TextField {...params} label="controllable" />
                )}
                filterOptions={(x) => x}
            />
        </>
    );
}

export function ContactViewerFetching() {
    return <Box>Fetching</Box>;
}

export function ContactViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}

function ChipStack({
    contacts,
    onRemove,
}: {
    contacts: Contact[];
    onRemove: (contact: Contact) => void;
}) {
    const sorted = React.useMemo(
        () =>
            [...contacts].sort((a, b) =>
                a.first_name.localeCompare(b.first_name),
            ),
        [contacts],
    );
    return (
        <Stack direction="row" spacing={1}>
            {sorted.map((item) => (
                <Chip
                    key={item.metadata.id}
                    label={item.first_name}
                    onDelete={() => onRemove(item)}
                />
            ))}
        </Stack>
    );
}

/*
function ChipStack({ contacts }: { contacts: { [key: string]: Contact } }) {
    const list = Object.values(contacts);
    const sortedList = list.sort((a, b) =>
        a.first_name.localeCompare(b.first_name),
    );
    const [contactsV, setContacts] =
        React.useState<readonly Contact[]>(sortedList);
    const handleDelete = (contactToDelete: Contact) => {
        let newValue = contactsV.filter(
            (contact: Contact) =>
                contact.metadata.id !== contactToDelete.metadata.id,
        );
        setContacts(newValue);
        console.log(newValue);
    };
    return (
        <Stack direction="row" spacing={1}>
            {contactsV.map((item) => (
                <Chip
                    key={item.metadata.id}
                    label={item.first_name}
                    onDelete={() => handleDelete(item)}
                />
            ))}
        </Stack>
    );
}
// */
